"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/**
 * Thread.
 * This module represents Thread for processes. Thread is promisified dedicated web worker.
 * @module thread.js
 * @author @SurenAt93
 */

/**
 * The Thread class
 */


var Thread = function () {
  /**
   * Create a worker
   * @param {Object} worker - The worker for current thread
   * @returns {undefined}
   */
  function Thread(worker) {
    _classCallCheck(this, Thread);

    this.__worker = worker;
  }
  /**
   * Public method for postMessage
   * @param {any} data - The data for sending to web worker
   * @returns {Promise} - The Promisified worker
   */


  _createClass(Thread, [{
    key: "postMessage",
    value: function postMessage(data) {
      var _this = this;

      this.__worker.postMessage(data);

      return new Promise(function (resolve, reject) {
        _this.__worker.onmessage = function (msg) {
          return resolve(msg.data);
        };

        _this.__worker.onerror = function (err) {
          return reject(err);
        };
      });
    }
    /**
     * Public method for terminate web worker
     * @returns {undefined}
     */

  }, {
    key: "kill",
    value: function kill() {
      this.__worker.terminate();
    }
  }]);

  return Thread;
}();

exports.default = Thread;